import { render, staticRenderFns } from "./DemoFilters.vue?vue&type=template&id=0133ab83&"
import script from "./DemoFilters.vue?vue&type=script&lang=js&"
export * from "./DemoFilters.vue?vue&type=script&lang=js&"
import style0 from "./DemoFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports